// @flow
require('iframe-resizer/js/iframeResizer.contentWindow');
// cookie lista se vkládá skrz GTM

import connectWebActions             from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents }      from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks                from 'fg-frontend/src/components/safeBlankLinks';

import configureWebComponents from './configureWebComponents';
import configureWebActions    from './configureWebActions';
// import phoneLink              from 'fg-frontend/components/PhoneLink';
import 'fg-frontend/ramjet/liveValidation';
// import('./components/plUpload/fg.upload');                // PL upload
// import 'bootstrap/js/dist/collapse';
import rememberFormId         from './webActions/rememberFormId';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, [ 'keyup', 'change' ]);
autoTitleLinksWithBlankTarget();
// phoneLink();
rememberFormId();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-majetek/src/js/configureWeb.js